// UID: NPO-HOA-CAPEX-FILE
// https://sunstonecreditinc.atlassian.net/browse/SUNENG-2246
import loanFormModel from '../../form_models/loanFormModel';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import FileNameValidationSchema from '../../../../../../../validations/FileNameValidationSchema';
import { Validation } from '../../../../../../../validations/Validation';
import { RulesetResult } from '../../business/rules';
import ReserveStudyRuleset from '../../business/ruleset/ReserveStudyRuleset';

const { reserveStudy } = loanFormModel.formField.hoaDocuments;

export class ReserveStudyValidation implements ValidationSchema {
  public name = reserveStudy.name;
  public label = '';
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };

  public ruleset = ReserveStudyRuleset;

  public when(schema: any, context: any, rulesetResult: RulesetResult) {
    const required = !!(rulesetResult & RulesetResult.REQUIRED);
    const fileSchema = FileNameValidationSchema(reserveStudy.name, required);
    if (required) {
      return fileSchema.required('This document is required');
    }
    return fileSchema;
  }
}
export default new Validation(new ReserveStudyValidation());
